/* Live Free — the Files index. Two small jobs, both optional.

   The filter rail is a <details> that ships OPEN, so with JS off the facets are
   simply visible inline and everything still filters through ordinary links.
   This only collapses it on small screens, where an always-open rail would push
   the archive off the first screen. */
(function () {
  'use strict';

  var rail = document.querySelector('[data-lf-rail]');
  var MOBILE = 900;

  if (rail) {
    // Collapse once at load on small screens; never fight the user afterwards.
    if (window.innerWidth < MOBILE) rail.open = false;

    // On desktop the rail's own toggle is hidden, so a rail left closed after a
    // resize would be unreachable. Force it back open whenever we're wide.
    window.addEventListener('resize', function () {
      if (window.innerWidth >= MOBILE && !rail.open) rail.open = true;
    });
  }

  // "Copy this view" — the archive URL carries its own filter state, so the
  // link alone is the shareable thing. Confirms, then reverts.
  document.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-lf-copy-url]');
    if (!btn) return;

    var idle = btn.dataset.lfCopyLabel || btn.textContent;
    var done = btn.dataset.lfCopyDone || 'copied';
    var url = window.location.href;

    function flash() {
      btn.textContent = done;
      btn.classList.add('is-done');
      window.setTimeout(function () {
        btn.textContent = idle;
        btn.classList.remove('is-done');
      }, 2000);
    }

    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(url).then(flash).catch(function () {});
    }
  });
})();